/**
 * La espera, y la puerta cerrada.
 *
 * Las dos pantallas que cada `*Layout` y cada página resolvía por su cuenta con
 * un `min-h-screen flex items-center justify-center` distinto. Acá son una
 * sola, para que el momento en que la app todavía no sabe nada se vea igual en
 * el candidato y en la agencia.
 */
import type { ReactNode } from 'react';

export function Waiting({ label }: { label?: string }) {
  return (
    <div className="gate" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-3">
        <span className="loading loading-spinner loading-lg" />
        {label && <span className="brand-label">{label}</span>}
      </div>
    </div>
  );
}

/** La espera dentro de una pantalla que ya tiene su encabezado puesto. */
export function WaitingInline({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-3 py-16" role="status" aria-live="polite">
      <span className="loading loading-spinner loading-lg" />
      {label && <span className="brand-label">{label}</span>}
    </div>
  );
}

/** Una sola frase, una sola salida: el patrón de "no perteneces a una agencia". */
export function Gate({
  title,
  children,
  action,
}: {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="gate">
      <div className="card rise w-full max-w-md">
        <div className="card-body items-center text-center gap-2">
          <img src="/brand/mascot-256.png" alt="" width={64} height={64} className="mb-1" />
          <h1 className="card-title">{title}</h1>
          {children}
          {action && <div className="mt-3">{action}</div>}
        </div>
      </div>
    </div>
  );
}
